import { Photos } from '@frontend/photos';
import { theme } from '@frontend/theme';
import { Checkbox, NakedButton, Text, useFormField } from '@frontend/design-system';

type PersonSelectionListItemProps = {
  personId: string;
  personName: string;
  onSelect: () => void;
  multiSelect?: boolean;
  isSelected?: boolean;
  disabled?: boolean;
};

export const PersonSelectionListItem = ({
  personId,
  personName,
  onSelect,
  multiSelect,
  isSelected,
  disabled,
}: PersonSelectionListItemProps) => {
  const checkboxFormField = useFormField(
    {
      type: 'checkbox',
      value: isSelected,
    },
    [isSelected]
  );

  return (
    <NakedButton
      onClick={disabled ? () => {} : onSelect}
      css={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: theme.spacing(2, 1),
        borderBottom: `1px solid ${theme.colors.neutral20}`,
        width: '100%',
        ':hover': disabled
          ? undefined
          : {
              backgroundColor: theme.colors.neutral5,
            },
        ':focus': {
          backgroundColor: theme.colors.neutral5,
          outline: 'none',
        },
        '*': {
          transition: 'opacity 300ms ease-in-out',
          opacity: disabled ? 0.5 : 1,
        },
        cursor: disabled ? 'default' : 'pointer',
      }}
      disabled={disabled}
      tabIndex={0}
    >
      <span
        css={{
          display: 'flex',
          gap: theme.spacing(2),
          alignItems: 'center',
        }}
      >
        {!!multiSelect && <Checkbox {...checkboxFormField} name={`${personId}-checkbox`} error={false} />}
        <Photos.ContactProfilePhoto personId={personId} name={personName} disableClick />
        <Text weight='bold'>{personName}</Text>
      </span>
    </NakedButton>
  );
};
